import './instrument.ts'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { installAiAnalyticsFetchGuard } from '@/lib/api/aiCreditsGuard'

installAiAnalyticsFetchGuard()

// Disable scroll-wheel increment/decrement on number inputs app-wide.
// Industry-standard pattern: when a number input gains focus, attach a
// non-passive wheel listener directly on it that preventDefault()s. Remove on
// blur. This guarantees the increment never fires (preventDefault wins, no
// race) while keeping the rest of the page's scroll perf untouched (no global
// non-passive wheel listener on document).
if (typeof document !== 'undefined') {
  const blockWheel = (e: WheelEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  document.addEventListener(
    'focusin',
    (e) => {
      const t = e.target as HTMLElement | null;
      if (t && t instanceof HTMLInputElement && t.type === 'number') {
        t.addEventListener('wheel', blockWheel, { passive: false });
      }
    },
    true,
  );
  document.addEventListener(
    'focusout',
    (e) => {
      const t = e.target as HTMLElement | null;
      if (t && t instanceof HTMLInputElement && t.type === 'number') {
        t.removeEventListener('wheel', blockWheel);
      }
    },
    true,
  );
}

createRoot(document.getElementById("root")!).render(<App />);
